import React, { useState } from 'react';
import { useEffect } from 'react';

import { stepInfo } from './data';

import styles from './case_steps.module.css';

const CaseSteps = ({ type }) => {
  const data = stepInfo[type || 'catering'];
  const { defaultStep, steps, contents } = data;

  const [activeStep, setActiveStep] = useState(defaultStep);
  const [subSteps, setSubSteps] = useState(null);
  const [activeSubStep, setActiveSubStep] = useState(0);

  const onSelectStep = (stepName) => {
    setActiveStep(stepName);
  };

  useEffect(() => {
    if (!type) return;

    setActiveStep(defaultStep);
  }, [type, defaultStep]);

  useEffect(() => {
    if (!activeStep || !contents) return;

    const step = contents.find((content) => content.step === activeStep);
    const subStep = step?.subStep || null;
    setSubSteps(subStep);
    setActiveSubStep(0);
  }, [activeStep, contents]);

  return (
    <>
      <div className={styles.container}>
        <div className={styles.stepContainer}>
          <div className={styles.notice}>버튼을 클릭해주세요</div>
          <div className={styles.stepBox}>
            {steps &&
              steps.map((stepColumn) => {
                const { title, list, isBetween } = stepColumn;

                return (
                  <div key={title} className={styles.column}>
                    <div className={styles.columnTitle}>{title}</div>
                    <div
                      className={`${styles.steps} ${
                        isBetween ? styles.between : ''
                      } ${
                        type === 'unmanned' && title === '점주님'
                          ? styles.unmanned
                          : ''
                      } `}
                    >
                      {list.map((step, index) => {
                        return (
                          <div
                            key={index}
                            className={
                              step === ''
                                ? styles.emptyStep
                                : activeStep === step
                                ? [styles.step, styles.activeStep].join(' ')
                                : styles.step
                            }
                            onClick={() =>
                              step === '' ? null : onSelectStep(step)
                            }
                          >
                            {step}

                            {index !== list.length - 1 && step !== '' ? (
                              <div className={styles.verticalLine} />
                            ) : null}

                            {isBetween && step !== '' && (
                              <span className={styles.blueTag}></span>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              })}
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.titleBox}>
            <div className={styles.title}>{activeStep || ''}</div>
            <div className={styles.subStepBox}>
              {subSteps &&
                subSteps.map((subStep, index) => {
                  let { name } = subStep;

                  return (
                    <div
                      key={index}
                      className={
                        activeSubStep === index
                          ? [styles.activeSubStep, styles.subStepBtn].join(' ')
                          : styles.subStepBtn
                      }
                      onClick={() => setActiveSubStep(index)}
                    >
                      {name}
                    </div>
                  );
                })}
            </div>
          </div>
          <div className={styles.description}>
            {(contents &&
              contents.find((content) => content.step === activeStep)?.desc) ||
              (subSteps && subSteps[activeSubStep].desc) ||
              ''}
          </div>
          <div className={styles.imgWrapper}>
            <img
              src={
                process.env.PUBLIC_URL +
                `/imgs/case/${type}/${activeStep}_${activeSubStep + 1}.png`
              }
              alt={`/imgs/${type}/${activeStep}_${activeSubStep + 1}`}
            />
          </div>
        </div>

        <div className={styles.mobileContainer}>
          <div className={styles.mStepBox}>
            {contents &&
              contents.map((content, index) => {
                const { step, subStep } = content;

                return (
                  <div key={index} className={styles.mStep}>
                    <div className={styles.stepTitle}>
                      <div className={styles.titleIcon}></div> {step}
                    </div>
                    {subStep && (
                      <ul className={styles.mSubSteps}>
                        {subStep.map((sub) => (
                          <li key={sub.name} className={styles.subTitle}>
                            {sub.name}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
};

export default CaseSteps;
